<template>
    <div v-if="active" class="card">
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <Error ref="error" />
        <div class="card-body text-center">
            <PageHeader :title="screenData.text.cardTitle" variant="small" class="mb-4" />
            <h3 class="mb-4 h5">{{screenData.text.yourUsername}}</h3>
            <p><fa-icon :icon="['fas','user']" class="theme-primary mx-2" />{{userId}}</p>
            <p>{{screenData.text.pleaseNote}}</p>
            <ActionList :actions="screenData.actions" @retrieve-user="startLogin" @setup-mfa-method="setupMfaMethod"></ActionList>
        </div>
    </div>
</template>

<script>
    import { nextTick } from 'vue'
    import Error from '../entities/Error.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';
    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';
    //import {goToIndexPage} from '../../../../src/utility/miscellaneous';

    export default {
        name: "RetrieveUsername",

        components: {
            Error,
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        props: {
            screenData: Object
        },

        data: function() {
            return {
                active: false,
                userId: "",
                nextObj: null,
                links: null,
            }
        },

        methods: {
            //goToIndexPage,
            show: function(data) {
                this.userId = data.userId;
                this.links = data.links;
                this.nextObj = data.nextObj;
                this.active = true;
                
                this.$axios.get(window.location.origin + `/BFWeb/cwapi/${this.getClient()}/authn/cancel`);
                nextTick(function() {
                    if (data.error !== undefined) {
                        this.$refs["error"].display(data.error.errorCode, data.error.errorMessage, data.error.errorType);
                    }
                }.bind(this))
            },

            hide: function() {
                this.active = false;
            },

            setUserId: function(val) {
                this.userId = val;
            },

            startLogin: function() {
                this.$emitter.emit('start-loading','retrieve-user');
                this.$root.loginusername = this.userId;
                //this.goToIndexPage();
                this.$emitter.emit('navigate', { componentName: 'login', routeData: this.userId });
                //this.start(this.links);
            },
            
            setupMfaMethod: function() {
                this.$emitter.emit('start-loading','setup-mfa-method');
                this.$emitter.emit('navigate', 'login');
                this.$emitter.emit('stop-loading','setup-mfa-method');
            }
        },

        watch: {
            nextObj: function(val) {
                if (val !== undefined) {
                    nextTick(function() {
                        this.$emitter.emit('hide','retrieve-user');
                        this.$emitter.emit('show','setup-mfa-method');
                    }.bind(this));
                }
            }
        },

        inject: ['getClient']
    }
</script>